<template>
  <div class="catalog">
    <CatalogSection />
  </div>
</template>

<script>
import CatalogSection from '../components/CatalogSection'
export default {
  name: 'Catalog',
  components: {
    CatalogSection
  }
}
</script>
